module.exports = __webpack_public_path__ + "static/media/avatar-3.b5b7a6c5.png";